import { render, staticRenderFns } from "./EBF.vue?vue&type=template&id=ec6497d0&scoped=true"
import script from "./EBF.vue?vue&type=script&lang=js"
export * from "./EBF.vue?vue&type=script&lang=js"
import style0 from "./EBF.vue?vue&type=style&index=0&id=ec6497d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6497d0",
  null
  
)

export default component.exports